import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default class PresetCommunityCards {
  constructor() {
    this.flop1 = null;
    this.flop2 = null;
    this.flop3 = null;
    this.turn = null;
    this.river = null;
  };

  get numSet() {
    let numPreset = 0;

    if (this.flop1) {
      numPreset++;
    }

    if (this.flop2) {
      numPreset++;
    }

    if (this.flop3) {
      numPreset++;
    }

    if (this.turn) {
      numPreset++;
    }

    if (this.river) {
      numPreset++;
    }

    return numPreset;
  };
  get flopSet() {
    return this.flop1 && this.flop2 && this.flop3;
  };
  get turnSet() {
    return this.flop1 && this.flop2 && this.flop3 && this.turn;
  };
  get riverSet() {
    return this.flop1 && this.flop2 && this.flop3 && this.turn && this.river;
  };

  get array() {
    return utilities.general.getBoardCardsArrayFromObj(this);
  };
  get flopArray() {
    if (!this.flopSet) {
      throw new Error('Trying to get flop array when flop isn\'t set.');
    }

    return [ this.flop1, this.flop2, this.flop3 ];
  };
  get turnArray() {
    if (!this.turnSet) {
      throw new Error('Trying to get turn array when turn isn\'t set.');
    }

    return [ this.flop1, this.flop2, this.flop3, this.turn ];
  };
  get riverArray() {
    if (!this.riverSet) {
      throw new Error('Trying to get river array when river isn\'t set.');
    }

    return [ this.flop1, this.flop2, this.flop3, this.turn, this.river ];
  };

  get possiblePlayerStateIndexes() {
    if (this.riverSet) {
      return [0, 1, 2, 3];
    } else if (this.turnSet) {
      return [0, 1, 2];
    } else if (this.flopSet) {
      return [0, 1];
    } else {
      return [0];
    }
  };
  get lastPossiblePlayerStateIndex() {
    if (this.riverSet) {
      return 3;
    } else if (this.turnSet) {
      return 2;
    } else if (this.flopSet) {
      return 1;
    } else {
      return 0;
    }
  };
  get flopImagePaths() {
    return this.getArrayOfImagePaths(1);
  };
  get turnImagePaths() {
    return this.getArrayOfImagePaths(2);
  };
  get riverImagePaths() {
    return this.getArrayOfImagePaths(3);
  };

  get pairedBoard() {
    if (this.flopSet && this.ranks.length < 3) {
      return true;
    }

    if (this.turnSet && this.ranks.length < 4) {
      return true;
    }

    if (this.riverSet && this.ranks.length < 5) {
      return true;
    }

    return false;
  };
  get ranks() {
    let ranks = [];

    if (this.flop1) {
      ranks.push(this.flop1[0]);
    }

    if (this.flop2) {
      ranks.push(this.flop2[0]);
    }

    if (this.flop3) {
      ranks.push(this.flop3[0]);
    }

    if (this.turn) {
      ranks.push(this.turn[0]);
    }

    if (this.river) {
      ranks.push(this.river[0]);
    }

    return _.uniq(ranks);
  };

  getArrayOfImagePaths(playerStateIndex) {
    let arrayOfImagePaths = [];
    let arrayOfCards;
    let rankText;
    let suitText;

    if (playerStateIndex === 1) {
      arrayOfCards = this.flopArray;
    } else if (playerStateIndex === 2) {
      arrayOfCards = this.turnArray;
    } else if (playerStateIndex === 3) {
      arrayOfCards = this.riverArray;
    }

    arrayOfCards.forEach(function (card) {
      if (card[0] === 'a') {
        rankText = 'ace';
      } else if (card[0] === 'k') {
        rankText = 'king';
      } else if (card[0] === 'q') {
        rankText = 'queen';
      } else if (card[0] === 'j') {
        rankText = 'jack';
      } else if (card[0] === 't') {
        rankText = 'ten';
      } else if (card[0] === '9') {
        rankText = 'nine';
      } else if (card[0] === '8') {
        rankText = 'eight';
      } else if (card[0] === '7') {
        rankText = 'seven';
      } else if (card[0] === '6') {
        rankText = 'six';
      } else if (card[0] === '5') {
        rankText = 'five';
      } else if (card[0] === '4') {
        rankText = 'four';
      } else if (card[0] === '3') {
        rankText = 'three';
      } else if (card[0] === '2') {
        rankText = 'two';
      }

      if (card[1] === 'c') {
        suitText = 'clubs';
      } else if (card[1] === 's') {
        suitText = 'spades';
      } else if (card[1] === 'h') {
        suitText = 'hearts';
      } else if (card[1] === 'd') {
        suitText = 'diamonds';
      }

      arrayOfImagePaths.push(`/static/cards/${rankText}-of-${suitText}.png`);
    });

    return arrayOfImagePaths;
  };
  getArrayForState(stateName) {
    if (stateName === 'afterFlop') {
      return this.flopArray;
    } else if (stateName === 'afterTurn') {
      return this.turnArray;
    } else if (stateName === 'afterRiver') {
      return this.riverArray;
    } else {
      throw new Error('Invalid stateName.');
    }
  };
  getArrayForStateViaIndex(stateIndex) {
    if (stateIndex === 0) {
      return [];
    } else if (stateIndex === 1) {
      return this.flopArray;
    } else if (stateIndex === 2) {
      return this.turnArray;
    } else if (stateIndex === 3) {
      return this.riverArray;
    }
  };
  getArrayForStateViaStreet(street) {
    if (street === 'preflop') {
      return [];
    }

    else if (street === 'flop') {
      if (this.flopSet) {
        return this.flopArray;
      } else {
        return [];
      }
    }

    else if (street === 'turn') {
      if (this.turnSet) {
        return this.turnArray;
      } else if (this.flopSet) {
        return this.flopArray;
      } else {
        return [];
      }
    }

    else if (street === 'river') {
      if (this.riverSet) {
        return this.riverArray;
      } else if (this.turnSet) {
        return this.turnArray;
      } else if (this.flopSet) {
        return this.flopArray;
      } else {
        return [];
      }
    }

    else {
      throw new Error('Invalid street.');
    }
  };
  areAllCardsSet(stateIndex) {
    if (stateIndex === 1) {
      return this.flopSet;
    } else if (stateIndex === 2) {
      return this.turnSet;
    } else if (stateIndex === 3) {
      return this.riverSet;
    }
  };
};



// WEBPACK FOOTER //
// ./src/services/PresetCommunityCards.js